import React, { Fragment, useEffect } from "react";

import EducationAndProfessionalExperience from "./educationalAndProfessionalExperience/EducationAndProfessionalExperience";
import EmergencyContactAndFamilyBgr from "./emergencyContactAndFamilyBgr/EmergencyContactAndFamilyBgr";
import Declaration from "./declaration/Declaration";

const ContactDetailsForm = ({
  generalDetails,
  personalDetails,
  relationShipList,
  states,
  addRelationDetails,
  deleteRelationDetails,
  getRelationShipList,
  updatePersonalDetails
}) => {
  useEffect(() => {
    getRelationShipList();
  }, []);
  return (
    <Fragment>
      <EmergencyContactAndFamilyBgr
        personalDetails={personalDetails}
        generalDetails={generalDetails}
        updatePersonalDetails={updatePersonalDetails}
        relationShipList={relationShipList}
        addRelationDetails={addRelationDetails}
        deleteRelationDetails={deleteRelationDetails}
      />
      <EducationAndProfessionalExperience
        personalDetails={personalDetails}
        states={states}
        updatePersonalDetails={updatePersonalDetails}
      />
      <Declaration personalDetails={personalDetails} updatePersonalDetails={updatePersonalDetails} />
    </Fragment>
  );
};
export default ContactDetailsForm;
